import { render } from "./UseItemHealingPotion.vue?vue&type=template&id=66b2b9ac"
import script from "./UseItemHealingPotion.vue?vue&type=script&lang=js"
export * from "./UseItemHealingPotion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/hero/windowOverlay/UseItemHealingPotion.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66b2b9ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66b2b9ac', __exports__)) {
    api.reload('66b2b9ac', __exports__)
  }
  
  module.hot.accept("./UseItemHealingPotion.vue?vue&type=template&id=66b2b9ac", () => {
    api.rerender('66b2b9ac', render)
  })

}


export default __exports__